import CrudPage from '@modules/cruds/CrudPage';

import * as yup from 'yup';
import LabelForm from './LabelForm';
import { defaultConfigComponent } from './Labels';

const labelSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
});

const LabelPage = props => {
  return <CrudPage key={'labelPage'} configComponent={defaultConfigComponent} form={LabelForm} validationSchema={labelSchema} />;
};

export default LabelPage;
